<template>
  <div class="box" :class="isPoster ? 'isPoster':''">
    <div class="header" v-if="isPoster">
      <div class="title1">
          <i></i>
          <span></span>
          <b>战报</b>
      </div>
      <div class="annotation">
          <h1>{{ game.homeTeamName }} — {{ game.awayTeamName }}</h1>
          <p v-if="game.match">{{ game.match.chineseName }}</p>
          <p>{{ game.location }}</p>
          <p>{{ getFormatDate(game.beginDate, '{y}-{m}-{d} {h}:{m}:{s}') }} — {{ getFormatDate(game.endDate, '{y}-{m}-{d} {h}:{m}:{s}') }}</p>
      </div>
    </div>
    <div v-if="game.sportType === '橄榄球'">
      <DataTable :gameId="gameId" :data="list" name="球队" code="rugby" />
      <DataTable :gameId="gameId" :data="homeTeam" name="球员/号码" code="playerDate" width="110px"
        :title="`球员数据-${homeName}`" />
      <DataTable :gameId="gameId" :data="awayTeam" name="球员/号码" code="playerDate" width="110px"
        :title="`球员数据-${awayName}`" />
    </div>
    <div v-if="game.sportType === '篮球'">
      <div class="title">球队比分</div>
      <div class="basketball-box flex-center">
        <div class="left">
          <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球队</div>
          <div class="flex-center" v-for="item in teams" :key="item.id">{{ item.name }}</div>
        </div>
        <div class="right">
          <div class="right-title">
            <div v-for="(item, i) in stages" :key="item.id" class="flex-center">{{ measure(i) }}</div>
            <div class="flex-center">总分</div>
          </div>
          <div class="teams flex-center flex-center1">
            <div v-for="team in stages" :key="team.id" class="flex-center">{{ team.homeScore }}</div>
            <div class="flex-center">{{ game.homeScore }}</div>
          </div>
          <div class="teams flex-center flex-center1">
            <div v-for="team in stages" :key="team.id" class="flex-center">{{ team.awayScore }}</div>
            <div class="flex-center">{{ game.awayScore }}</div>
          </div>
        </div>
      </div>
      <div class="title">全场最佳</div>
      <div class="mvp">
        <div class="item" v-for="item in topPlayers" :key="item.type">
          <div class="top"><i></i><span></span>
            <p>{{ item.type }}</p>
          </div>
          <div class="fen">{{ item.top }}</div>
          <div class="info flex-center">
            <img v-if="item.player.avatar" :src="filterImage(item.player.avatar, 80, 80)" />
            <img v-else src="@/assets/images/Mensingles.png" />
            <div class="info-box">
              <p>{{ item.player.trueName }}</p>
              <span>{{ item.player.number }}号/{{ item.player.position ? item.player.position + '/' : '' }}{{
                item.player.teamName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="title">球队数据</div>
      <div class="basketball-box flex-center">
        <div class="left">
          <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球队</div>
          <div class="flex-center" v-for="item in teams" :key="item.id">{{ item.name }}</div>
        </div>
        <div class="right">
          <div class="right-title">
            <div class="flex-center">得分</div>
            <div class="flex-center">助攻</div>
            <div class="flex-center">盖帽</div>
            <div class="flex-center">抢断</div>
            <div class="flex-center">篮板</div>
            <div class="flex-center" v-if="mode == 1">前场<br />篮板</div>
            <div class="flex-center" v-if="mode == 1">后场<br />篮板</div>
            <div class="flex-center" v-if="mode == 1">两分<br />命中率</div>
            <div class="flex-center" v-if="mode == 1">三分<br />命中率</div>
            <div class="flex-center" v-if="mode == 1">罚球<br />命中率</div>
            <div class="flex-center">失误</div>
            <div class="flex-center">犯规</div>
          </div>
          <div class="teams flex-center" v-for="item in teams" :key="item.id">
            <div class="flex-center">{{ item.score }}</div>
            <div class="flex-center">{{ item.assistCount || 0 }}</div>
            <div class="flex-center">{{ item.blockCount || 0 }}</div>
            <div class="flex-center">{{ item.stealCount || 0 }}</div>
            <div class="flex-center">{{ item.reboundCount || 0 }}</div>
            <div class="flex-center" v-if="mode == 1">{{ item.frontReboundCount || 0 }}</div>
            <div class="flex-center" v-if="mode == 1">{{ item.backReboundCount || 0 }}</div>
            <div class="flex-center" v-if="mode == 1">{{ item.twoPointRate }}</div>
            <div class="flex-center" v-if="mode == 1">{{ item.threePointRate }}</div>
            <div class="flex-center" v-if="mode == 1">{{ item.freeThrowRate }}</div>
            <div class="flex-center">{{ item.turnoverCount || 0 }}</div>
            <div class="flex-center">{{ item.foulCount || 0 }}</div>
          </div>
        </div>
      </div>
      <div v-for="item in teams" :key="item.id">
        <div class="title">球队数据-{{ item.name }}</div>
        <div class="basketball-box flex-center">
          <div class="left">
            <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球队 / 号码</div>
            <div class="flex-center" v-for="(player, i) in item.players" :key="player.id"
              :style="{ color: i < 3 ? '#0D7096' : '' }">
              <span class="overflow-text"> {{ player.trueName }}</span> / {{ player.number }}
              <img src="@/assets/images/shoufa.png" v-if="player.first" />
            </div>
          </div>
          <div class="right">
            <div class="right-title">
              <div class="flex-center">得分</div>
              <div class="flex-center">助攻</div>
              <div class="flex-center">篮板</div>
              <div class="flex-center">盖帽</div>
              <div class="flex-center">抢断</div>
              <div class="flex-center">两分</div>
              <div class="flex-center">三分</div>
              <div class="flex-center">罚球</div>
              <div class="flex-center">失误</div>
              <div class="flex-center">犯规</div>
            </div>
            <div class="teams flex-center flex-center1" v-for="player in item.players" :key="player.id">
              <div class="flex-center">{{ player.score }}</div>
              <div class="flex-center">{{ player.assistCount }}</div>
              <div class="flex-center">{{ player.reboundCount }}</div>
              <div class="flex-center">{{ player.blockCount }}</div>
              <div class="flex-center">{{ player.stealCount }}</div>
              <div class="flex-center">
                <span v-if="mode == 1">{{ player.twoPointCount + '/' + player.twoPointTotal }}</span>
                <span v-if="mode == 0">{{ player.twoPointCount }}</span>
              </div>
              <div class="flex-center">
                <span v-if="mode == 1">{{ player.threePointCount + '/' + player.threePointTotal }}</span>
                <span v-if="mode == 0">{{ player.threePointCount }}</span>
              </div>
              <div class="flex-center">
                <span v-if="mode == 1">{{ player.freeThrowCount + '/' + player.freeThrowTotal }}</span>
                <span v-if="mode == 0">{{ player.freeThrowCount }}</span>
              </div>
              <div class="flex-center">{{ player.turnoverCount }}</div>
              <div class="flex-center">{{ player.foulCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">技术统计</div>
      <div class="statistics">
        <div class="info-top flex-center">
          <div class="flex-center" style="justify-content: right;">
            {{ game.homeTeam.name }}
            <img v-if="game.homeTeam.badge" :src="filterImage(game.homeTeam.badge, 40, 40)" />
            <img v-else src="@/assets/images/Mensingles.png" />
          </div>
          <div class="flex-center">
            <img v-if="game.awayTeam.badge" :src="filterImage(game.awayTeam.badge, 40, 40)" />
            <img v-else src="@/assets/images/Mensingles.png" />
            {{ game.awayTeam.name }}
          </div>
        </div>
        <div class="item" v-for="(item, i) in game.technicalData" :key="i">
          <div class="info flex-center">
            <div>{{ innerHtmlPercent(item, 'home') }}</div>
            <div style="text-align: center;">{{ item.title }}</div>
            <div style="text-align: right;">{{ innerHtmlPercent(item, 'away') }}</div>
          </div>
          <div class="score flex-center">
            <div><span :style="widthCalc(item, 'home')"></span></div>
            <div><span :style="widthCalc(item, 'away')"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="game.sportType === '足球' && isDate">
      <div class="title">球队数据</div>
      <div class="basketball-box flex-center">
        <div class="left">
          <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球队</div>
          <div class="flex-center">{{ homeTeam.name }}</div>
          <div class="flex-center">{{ awayTeam.name }}</div>
        </div>
        <div class="right">
          <div class="right-title">
            <div v-for="item in football" :key="item.val" class="flex-center">{{ item.label }}</div>
          </div>
          <div class="teams flex-center">
            <div v-for="team in football" :key="team.val" class="flex-center">{{ homeTeam.stats[team.val] }}</div>
          </div>
          <div class="teams flex-center">
            <div v-for="team in football" :key="team.val" class="flex-center">{{ awayTeam.stats[team.val] }}</div>
          </div>
        </div>
      </div>
      <div class="title">全场最佳</div>
      <div class="mvp-football">
        <div class="mvp-main" v-if="topPlayers.goal[0].length != 0 || topPlayers.goal[1].length != 0">
          <div class="mvp-left-name">
            <div v-for="(item, i) in topPlayers.goal[0]" :key="i">{{ item.playerName }}</div>
          </div>
          <div class="mvp-left-val">
            {{ topPlayers.goal[0][0].value || 0 }}
          </div>
          <div class="mvp-label">
            进球
          </div>
          <div class="mvp-right-val">
            {{ topPlayers.goal[1][0].value || 0 }}
          </div>
          <div class="mvp-right-name">
            <div v-for="(item, i) in topPlayers.goal[1]" :key="i">{{ item.playerName }}</div>
          </div>
        </div>
        <div class="mvp-main" v-if="topPlayers.keyPass[0].length != 0 || topPlayers.keyPass[1].length != 0">
          <div class="mvp-left-name">
            <div v-for="(item, i) in topPlayers.keyPass[0]" :key="i">{{ item.playerName }}</div>
          </div>
          <div class="mvp-left-val">
            {{ (topPlayers.keyPass[0] && topPlayers.keyPass[0][0] && topPlayers.keyPass[0][0].value) || 0 }}
          </div>
          <div class="mvp-label">
            关键传球
          </div>
          <div class="mvp-right-val">
            {{ (topPlayers.keyPass[1] && topPlayers.keyPass[1][0] && topPlayers.keyPass[1][0].value) || 0 }}
          </div>
          <div class="mvp-right-name">
            <div v-for="(item, i) in topPlayers.keyPass[1]" :key="i">{{ item.playerName }}</div>
          </div>
        </div>
        <div class="mvp-main" v-if="topPlayers.dribblePast[0].length != 0 || topPlayers.dribblePast[1].length != 0">
          <div class="mvp-left-name">
            <div v-for="(item, i) in topPlayers.dribblePast[0]" :key="i">{{ item.playerName }}</div>
          </div>
          <div class="mvp-left-val">
            {{ topPlayers.dribblePast[0][0].value || 0 }}
          </div>
          <div class="mvp-label">
            过人成功
          </div>
          <div class="mvp-right-val">
            {{ topPlayers.dribblePast[1][0].value || 0 }}
          </div>
          <div class="mvp-right-name">
            <div v-for="(item, i) in topPlayers.dribblePast[1]" :key="i">{{ item.playerName }}</div>
          </div>
        </div>
        <div class="mvp-main" v-if="topPlayers.intercept[0].length != 0 || topPlayers.intercept[1].length != 0">
          <div class="mvp-left-name">
            <div v-for="(item, i) in topPlayers.intercept[0]" :key="i">{{ item.playerName }}</div>
          </div>
          <div class="mvp-left-val">
            {{ topPlayers.intercept[0][0].value || 0 }}
          </div>
          <div class="mvp-label">
            抢断
          </div>
          <div class="mvp-right-val">
            {{ topPlayers.intercept[1][0].value || 0 }}
          </div>
          <div class="mvp-right-name">
            <div v-for="(item, i) in topPlayers.intercept[1]" :key="i">{{ item.playerName }}</div>
          </div>
        </div>
      </div>
      <div class="title">球员数据-{{ homeTeam.name }}</div>
      <div class="basketball-box flex-center">
        <div class="left left1">
          <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球员 / 号码</div>
          <div class="flex-center" v-for="item in homeTeam.playerStats" :key="item.id">{{ item.playerName }} / {{
            item.number }}</div>
        </div>
        <div class="right">
          <div class="right-title">
            <div v-for="item in playerDate" :key="item.val" class="flex-center">{{ item.label }}</div>
          </div>
          <div class="teams flex-center" v-for="item in homeTeam.playerStats" :key="item.id">
            <div v-for="team in playerDate" :key="team.val" class="flex-center">{{ item.stats[team.val] || 0 }}</div>
          </div>
          <!-- <div class="teams flex-center">
              <div v-for="team in football" :key="team.val" class="flex-center">{{ awayTeam.stats[team.val] }}</div>
            </div> -->
        </div>
      </div>
      <div class="title">球员数据-{{ awayTeam.name }}</div>
      <div class="basketball-box flex-center">
        <div class="left left1">
          <div class="flex-center" style="background-color: #EC4E4E;color: #fff;">球员 / 号码</div>
          <div class="flex-center" v-for="item in awayTeam.playerStats" :key="item.id">{{ item.playerName }} / {{
            item.number }}</div>
        </div>
        <div class="right">
          <div class="right-title">
            <div v-for="item in playerDate" :key="item.val" class="flex-center">{{ item.label }}</div>
          </div>
          <div class="teams flex-center" v-for="item in awayTeam.playerStats" :key="item.id">
            <div v-for="team in playerDate" :key="team.val" class="flex-center">{{ item.stats[team.val] || 0 }}</div>
          </div>
          <!-- <div class="teams flex-center">
              <div v-for="team in football" :key="team.val" class="flex-center">{{ awayTeam.stats[team.val] }}</div>
            </div> -->
        </div>
      </div>
    </div>

    <div class="footer" v-if="isPoster">
      <div class="footer-content" >
          <img src="@/assets/qr.png" alt="">
          <p>以上数据由邦马邦提供</p>
          <h4>更多服务请下载【斑马邦】 App</h4>
      </div>
      <div class="title1" >
          <i></i>
          <span></span>
          <b></b>
          <img class="black-logo" src="@/assets/blackLogo.png" alt="">
      </div>
  </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable'
import { getBMRugbyGameStats, getBMGameDetail, getBMGameBktData, getBMFootballGameStats } from '@/api/match'
import { QNImageUtil, DateUtil, removeUrlQueryItem } from '@/utils'
import { showShotBar, enableShare } from '@/libs/ds-bridge'

export default {
  components: {
    DataTable
  },
  data() {
    return {
      list: [],
      homeTeam: [],
      homeName: '',
      awayTeam: [],
      awayName: '',
      game: {},
      teams: [],
      stages: [],
      topPlayers: [],
      mode: null,
      football: [
        { label: '比分', val: 'score' },
        { label: '控球率', val: 'ballPossessionRatio' },
        { label: '射门', val: 'shoot' },
        { label: '射正', val: 'onTarget' },
        { label: '射正率', val: 'onTargetRatio' },
        { label: '前场任意球', val: 'frontFieldFreeKick' },
        { label: '角球', val: 'conner' },
        { label: '关键传球', val: 'keyPass' },
        { label: '过人成功', val: 'dribblePast' },
        { label: '越位', val: 'offside' },
        { label: '犯规', val: 'foul' },
        { label: '红牌', val: 'redCard' },
        { label: '黄牌', val: 'yellowCard' },
        { label: '抢断', val: 'intercept' },
      ],
      playerDate: [
        { label: '出场时间', val: 'enterTime' },
        { label: '进球', val: 'goal' },
        { label: '助攻', val: 'assist' },
        { label: '射门', val: 'shoot' },
        { label: '射正', val: 'onTarget' },
        { label: '射正率', val: 'onTargetRatio' },
        { label: '关键传球', val: 'keyPass' },
        { label: '过人成功', val: 'dribblePast' },
        { label: '越位', val: 'offside' },
        { label: '犯规', val: 'foul' },
        { label: '红牌', val: 'redCard' },
        { label: '黄牌', val: 'yellowCard' },
        { label: '抢断', val: 'intercept' },
        { label: '扑救', val: 'rescue' },
      ],
      isDate: false, // 获取到数据后再渲染页面
      isPoster: false, //
    };
  },
  created() {
    this.gameId = this.$route.query.gameId
    this.isPoster = this.$route.query.isPoster ? true : false;
    this.getBMGameDetail()
  },
  methods: {
    getFormatDate(date,type) {
      return DateUtil.parseDateTime(date, type)
    },
    getBMGameDetail() {
      getBMGameDetail({ gameId: this.gameId }).then(res => {
        const data = res.data
        const game = data.game
        this.game = game
        console.log(game.homeTeamName);
        this.mode = game.liveTagMode
        if (game.sportType === '橄榄球') {
          this.getBMRugbyGameStats()
        } else if (game.sportType === '篮球') {
          this.getBMGameBktData()
        } else if (game.sportType === '足球') {
          this.getBMFootballGameStats()
        }
        if (this.isPoster) {
          showShotBar()
        }
        const shareImg = (game.match && game.match.icon) ? this.filterImage(game.match.icon, 150, 150) : null;
        const params = {
          title: game.homeTeam.name + ' vs ' + game.awayTeam.name,
          desc: '比赛数据',
          imgUrl: shareImg,
          hasScreenshot: true,
          contentWidth: 840,
          link: removeUrlQueryItem(window.location.href, 'passport')
        }
        enableShare(params)
      })
    },
    getBMFootballGameStats() {
      getBMFootballGameStats({ gameId: this.gameId }).then(res => {
        const data = res.data
        this.homeTeam = data.homeTeam
        this.awayTeam = data.awayTeam
        this.topPlayers = data.topPlayers
        this.isDate = true
      })
    },
    getBMRugbyGameStats() {
      const param = {
        mode: 1,
        gameId: this.gameId
      }
      getBMRugbyGameStats(param).then(res => {
        const data = res.data
        this.homeTeam = data.homeTeam.playerStats.map(item => {
          item.name = item.playerName
          return item
        })
        this.awayTeam = data.awayTeam.playerStats.map(item => {
          item.name = item.playerName
          return item
        })

        this.homeName = data.homeTeam.name
        this.awayName = data.awayTeam.name
        this.list.push(data.homeTeam)
        this.list.push(data.awayTeam)
      })
    },
    getBMGameBktData() {
      getBMGameBktData({ mode: 0, gameId: this.gameId }).then(res => {
        const data = res.data
        this.teams = data.teams
        this.stages = data.stages
        const game = data.game
        game.homeTeamName = game.homeTeam.name
        game.awayTeamName = game.awayTeam.name
        this.game = game
        this.topPlayers = data.topPlayers
        console.log(this.teams);
      })
    },
    measure(index) {
      var arr = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th'];
      if (index > 2) {
        return index + 1 + 'th';
      } else {
        return arr[index];
      }
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    innerHtmlPercent(item, type) {
      if (item.title === "两分命中率" || item.title === "三分命中率" || item.title === "罚球命中率") {
        if (type === 'home') {
          return item.home + '%';
        } else if (type === 'away') {
          return item.away + '%';
        }
      } else {
        if (type === 'home') {
          return item.home;
        } else if (type === 'away') {
          return item.away;
        }
      }
    },
    widthCalc(item, type) {
      var sum = item.home + item.away;
      var percent = null;
      if (item.title === "两分命中率" || item.title === "三分命中率" || item.title === "罚球命中率") {
        if (type === 'home') {
          percent = item.home / 100 * 100;
        } else if (type === 'away') {
          percent = item.away / 100 * 100;
        }
        return { width: percent + '%' }
      }
      if (type === 'home') {
        return { width: item.home / sum * 100 + '%' }
      } else if (type === 'away') {
        return { width: item.away / sum * 100 + '%' }
      }
    }
  },
};
</script>

<style scoped lang="scss">
div {
  box-sizing: border-box;
}

.box {
  background-color: #F5F5F5;
  padding-bottom: 10px;
  .header{
    padding: 15px;
    background-color: white;
    max-width: 840px;
    width: 840px;
    display: flex;
    position: relative;
    .annotation{
      h1 {
        font-size: 24px;
        color: #464646;
        font-weight: 400;
        margin-top: 0;
        margin-bottom: 5px;
      }
      p {
        color: #9B9B9B;
        font-size: 12px;
        margin-bottom: 0;
        font-weight: 400;
        margin-top: 0;
      }
    }
  }
}
    .title1{
      position: relative;
      width: 200px;
      height: 60px;
      i {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: #0D7096;
        height: 60px;
        width: 40px;
      }
      span {
        display: inline-block;
        width: 160px;
        height: 60px;
        background-color: #EC4E4E;
        transform: skewX(-30deg);
        top: 0;
        left: 18px;
        position: absolute;
        z-index: 2;
      }
      b {
        position: absolute;
        left: 45px;
        top: 3px;
        color: #fff;
        z-index: 3;
        font-size: 38px;
        font-weight: 400;
        letter-spacing: 2px;
      }
    }
.title {
  padding: 15px;
  font-size: 18px;
  background-color: #F5F5F5;
}

.mvp-football {
  padding: 15px;
  background-color: #fff;
  width: 100vw;
  .mvp-main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    font-size: 14px;
    color: #333;

    &:nth-child(odd) {
      background-color: #F8F8F8;
    }

    .mvp-left-name {
      width: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .mvp-left-val {
      width: 20%;
      text-align: center;
    }

    .mvp-label {
      width: 20%;
      text-align: center;
      font-weight: 600;
    }

    .mvp-right-val {
      width: 20%;
      text-align: center;
    }

    .mvp-right-name {
      width: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.isPoster{
  width: 780px;
  overflow: hidden;
  *{
    box-sizing: border-box;
  }
  .title{
    width:  780px;
  }
  .right{
    overflow: visible !important;
  }
  .flex-center1{
    justify-content: start !important;
  }
  .mvp{
    overflow: visible !important;
    flex-wrap: wrap;
  }
  .right-title{
    div{
      width: 7.1% !important;
      min-width: 7.1% !important;
      max-width: 7.1% !important;
    }
  }
  .teams{
    justify-content: start !important;
    div{
      width: 7.1% !important;
      min-width: 7.1% !important;
      max-width: 7.1% !important;
    }
  }
  .flex-center{
    // justify-content: start !important;
    text-align: center;
  }
}
.basketball-box {
  margin-left: 15px;

  .left {
    box-shadow: 4px 4px 6px 2px rgba(0, 0, 0, .06);
    position: relative;
    z-index: 3;
    width: 100px;

    div {
      position: relative;
      height: 56px;
      width: 100px;
      justify-content: center;
      font-size: 14px;
      font-weight: 500;

      &:nth-child(2n) {
        background-color: #F8F8F8;
      }

      span {
        max-width: 60px;
        margin-right: 4px;
      }
    }

    img {
      width: 32px;
      height: 32px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .left1 {
    div {
      font-size: 12px !important;
    }
  }

  .right {
    flex: 1;
    overflow: scroll;
    background-color: #F5F5F5;
    .right-title {
      display: flex;

      div {
        text-align: center;
        width: 60px;
        min-width: 60px;
        height: 56px;
        justify-content: center;
        background-color: #0D7096;
        color: #fff;
        font-size: 14px;
      }
    }

    .teams {
      height: 56px;
      &:nth-child(n) {
        div {
          background-color: #fff;
        }
      }
      &:nth-child(2n) {
        div {
          background-color: #F8F8F8;
        }
      }

      div {
        width: 60px;
        min-width: 60px;
        height: 56px;
        justify-content: center;
        font-size: 14px;
      }
    }
  }
}

.mvp {
  padding: 15px;
  background-color: #fff;
  width: 100%;
  overflow-x: scroll;
  display: flex;

  .item {
    width: 222px;
    min-width: 222px;
    background-color: #F8F8F8;
    height: 140px;
    margin-right: 10px;
    margin-bottom: 10px;

    .top {
      position: relative;

      i {
        position: absolute;
        z-index: 1;
        background-color: #0D7096;
        height: 28px;
        width: 30px;
      }

      span {
        display: inline-block;
        width: 80px;
        height: 28px;
        background-color: #EC4E4E;
        transform: skewX(-30deg);
        top: 0;
        left: 8px;
        position: absolute;
        z-index: 2;
      }

      p {
        position: absolute;
        z-index: 9;
        margin: 0;
        color: #fff;
        font-size: 12px;
        left: 14px;
        top: 6px;
      }
    }

    .fen {
      margin-top: 45px;
      font-size: 30px;
      margin-left: 18px;
      font-weight: 300;
    }

    .info {
      margin-left: 15px;
      margin-top: 10px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .info-box {
        margin-left: 10px;
        padding-right: 10px;

        p {
          margin: 0;
          font-size: 14px;
        }

        span {
          font-size: 12px;
          color: #9B9B9B;
        }
      }
    }
  }
}

.flex-center {
  display: flex;
  align-items: center;
}

.statistics {
  .info-top {
    justify-content: center;
    font-size: 14px;
    padding: 15px;

    div {
      flex: 1;
    }

    img {
      width: 40px;
      height: 40px;
      margin: 0 10px;
    }
  }

  .item {
    padding: 5px 10px;

    .info {
      font-size: 14px;
      margin-bottom: 15px;

      div {
        flex: 1;
      }

      justify-content: space-between;
    }

    .score {
      margin-bottom: 15px;

      div {
        position: relative;
        background: rgba(242, 242, 242, 1);
        height: 6px;
        width: 50%;

        // margin: 0 5px;
        &:nth-child(1) {
          margin-right: 3px;

          span {
            position: absolute;
            right: 0;
            height: 6px;
            background: #E84C4C;
          }
        }

        &:nth-child(2) {
          margin-left: 3px;

          span {
            position: absolute;
            left: 0;
            height: 6px;
            background: #0D7096;
          }
        }
      }
    }
  }
}

.footer{
  margin-top: 10px;
  background-color: #F5F5F5;
  display: flex;
  padding: 15px;
  width: 780px;
  height: 90px;
  box-sizing: border-box;
  justify-content: space-between;
  img {
    width: 80px;
    height: 80px;
    position: absolute;
  }
  img.black-logo {
    width:97px;
    height:40px;
    margin-right: 15px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  span{
    transform: skewX(30deg);
  }
  i{
      right: 0;
  }
  .footer-content {
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 320px;
    position: relative;
    p {
      font-size: 12px;
      color: #464646;
      margin-bottom: 5px;
    }
    h4 {
      font-size: 16px;
      color: #464646;
      font-weight: normal;
      margin: 0;
    }
}

}
::v-deep .title {
  background-color: #F5F5F5;
}

::v-deep .box {
  margin-top: 0px;
}</style>
